
import React from 'react';
import {Helmet} from "react-helmet";

function RichResult ({data}) {

    const data_json = JSON.stringify(data);

	return (<>
		<Helmet >
            <script type="application/ld+json">
                {data_json}
            </script>
        </Helmet>
	</>)
	
}

export default RichResult